import React, { useEffect, useRef, useState } from "react";
import styles from "./ORA.module.css";
import Plot from "react-plotly.js";
import axios from "axios";
import SankeyDiagram from "../SankeyPlot/SankeyPlot";
import TableORA from "../TableORA/TableORA";
import Table3SP from "../Table_3SP/Table_3SP";
import BubblePlot from "../BubblePlot/BubblePlot";
import html2canvas from "html2canvas";
import ScatterPlot from "../ScatterPlot/ScatterPlot";
import { jsPDF } from "jspdf";
import { CSVLink } from "react-csv";

const ORA = ({
  resultData,
  ORAType,
  loading,
  setLoading,
  err,
  sepBtnState,
  setSepBtnState,
  qValueCutoff,
}) => {

  useEffect(() => {
    console.log(resultData);
    console.log('000000')
}, [resultData])

  const countDB = localStorage.getItem("countDB");
  const parseCountDB =
    typeof countDB === "string"
      ? JSON.parse(countDB)
      : { lv1: 0, lv2: 0, lv3: 0, lv4: 0 };
  const values = [
    parseCountDB["lv1"],
    parseCountDB["lv2"],
    parseCountDB["lv3"],
    parseCountDB["lv4"],
  ];

  // Download Button for CSV
  const csvBtnRef = useRef(null);
  const handleDowndloadCSV = () => {
    csvBtnRef.current !== null && csvBtnRef.current.click();
  };

  // Gene pathway Network
  const [selectedRowsForSankey, setSelectedRowsForSankey] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
  ]);
  const [GenePathwayNetwork_result, setGenePathwayNetwork_result] = useState();
  const handleCreatePathwayNetwork = () => {
    const headers = {
      accept: "*/*",
      "Content-Type": "application/json",
    };
    const data = JSON.stringify(
      resultData
        .filter((_, index) => selectedRowsForSankey.includes(index))
        .map((item) => ({
          pathway: item.pathway,
          overlapGenes: item.entrez_id,
        }))
    );
    axios({
      method: "post",
      url: `${process.env.REACT_APP_BASE_URL}/network`,
      headers,
      data,
    })
      .then((res) => {
        const gene_pathway_network = res.data.gene_pathway_network;
        const parsed_gene_pathway_network = JSON.parse(gene_pathway_network);
        const gene_pathway_network_array = Object.values(
          parsed_gene_pathway_network
        );
        setGenePathwayNetwork_result(gene_pathway_network_array);
      })
      .then(() => {
        setSepBtnState("Gene_Pathway Network (Fig.1)");
      })
      .catch(() => {});
  };

  // PathwayData
  const [pathwayData, setPathwayData] = useState([]);
  const onHandlePathwayData = () => {
    const newPathwayData = resultData
        .filter((_, index) => selectedRowsForSankey.includes(index))
        .map((item) => {
          return {
            pathway: item.pathway,
            count: (item.overlap / item.size).toFixed(3),
            qValue: parseFloat(item.qvalue),
            pValue: parseFloat(item.pvalue_string),
          };
        })
        .sort((a, b) => a.pValue - b.pValue)
    const myNewObject = { pathway: '', count: 0, qValue: 0 }; // 추가하려는 객체
    const updatedPathwayData = [myNewObject, ...newPathwayData];
    setPathwayData(updatedPathwayData);
    setSepBtnState("Pathway Graph (Fig.2)");
  };

  //sankey diagram ref
  const svgRef = useRef(null);
  const downloadPdf = async () => {
    if (!svgRef.current) return;
    alert("download might take few minutes!")
    const canvas = await html2canvas(svgRef.current, { scale: 4 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("CANCER COMPASS_sankey diagram.pdf");
  };
  //Bubble plot ref
  const bubblePlotRef_qval = useRef(null);
  const bubblePlotRef_pval = useRef(null);
  const saveBubblePlotAsPDF_qval = async () => {
    if (!bubblePlotRef_qval.current) return;
    alert("download might take few minutes!")
    const canvas = await html2canvas(bubblePlotRef_qval.current, { scale: 4 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("CANCER COMPASS_bubble plot_qval.pdf");
  };
  const saveBubblePlotAsPDF_pval = async () => {
    if (!bubblePlotRef_pval.current) return;
    alert("download might take few minutes!")
    const canvas = await html2canvas(bubblePlotRef_pval.current, { scale: 4 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("CANCER COMPASS_bubble plot_pval.pdf");
  };  

  //3D scatter plot
  const [cordX, setCordX] = useState(0);
  const valueFromStorage = localStorage.getItem("intersec_ORA");
  const cordY = valueFromStorage ? parseInt(valueFromStorage) : 0; 
  const [cordZ, setCordZ] = useState(0);
  const [cordZcutoff, setCordZcutoff] = useState(0);
  const [isClicked3Sp, setIsClicked3SP] = useState("");

  //
  useEffect(() => {
    if (sepBtnState !== "") {
      setIsClicked3SP("");
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [sepBtnState]);

  useEffect(() => {
    setIsClicked3SP("");
  }, [qValueCutoff]);

  return (
    <div>
      <h1 className={styles.mainTitle} style={{ margin: 0 }}>
        ◼️ ORA Analysis Results
      </h1>
      {localStorage.getItem("intersec_ORA") && !err && (
        <p style={{ margin: 0 }}>
          🔍
          <span style={{ fontWeight: "bolder" }}>
            {" "}
            {localStorage.getItem("intersec_ORA")}{" "}
          </span>
          of
          <span style={{ fontWeight: "bolder" }}>
            {" "}
            {localStorage.getItem("total_ORA")}{" "}
          </span>
          accession numbers →
          <span style={{ fontWeight: "bolder" }}>
            {" "}
            {localStorage.getItem("percent_ORA")}%{" "}
          </span>
          from your input list were mapped!
        </p>
      )}
      <div className={styles.graph}>
        <div className={styles.infoCnt}>
          <h4 className={styles.subTitle}>
            {ORAType} Pathway Stratification Overview
          </h4>
          <div className={styles.levelCnt}>
            <div className={styles.level}>
              <span>
                ✔︎ Level 1 - {ORAType} Pathway (highest confidence; p &lt; 0.001)
              </span>
              {!err && (
                <span className={styles.countNum}>
                  {values[0] ? values[0] : "0"}
                </span>
              )}
            </div>
            <div className={styles.level}>
              <span>
                ✔︎ Level 2 - {ORAType} Pathway (high confidence; p &lt; 0.01){" "}
              </span>
              {!err && (
                <span className={styles.countNum}>
                  {values[1] ? values[1] : "0"}
                </span>
              )}
            </div>
            <div className={styles.level}>
              <span>
                ✔︎ Level 3 - {ORAType} Pathway (moderate confidence; p &lt; 0.05)
              </span>
              {!err && (
                <span className={styles.countNum}>
                  {values[2] ? values[2] : "0"}
                </span>
              )}
            </div>
            <div className={styles.level}>
              <span>
                ✔︎ Level 4 - Pathway with no significant {ORAType} association</span>
              {!err && (
                <span className={styles.countNum}>
                  {values[3] ? values[3] : "0"}
                </span>
              )}
            </div>
          </div>
        </div>
        {resultData.length !== 0 && (
          <div className={styles.plotCnt}>
            <div style={{ width: "200px", paddingLeft: "70px" }}>
              <Plot
                data={[
                  {
                    values: values,
                    labels: ["Level-1", "Level-2", "Level-3", "Level-4"],
                    domain: { column: 0 },
                    name: "Cancer Pathway",
                    hoverinfo: "label+percent+name",
                    hole: 0.4,
                    type: "pie",
                  },
                ]}
                layout={{
                  margin: {
                    t: 0,
                    r: 0,
                    b: 0,
                    l: 40,
                  },
                  height: 220,
                  width: 400,
                  autosize: true,
                  showlegend: false,
                  grid: { rows: 1, columns: 2 },
                }}
              />
            </div>
          </div>
        )}
      </div>
      <div>
        {resultData.length !== 0 && (
          <>
            <div style={{ display: "flex", alignItems: "center" }}>
              <h4 className={styles.subTitle}>
                Over-Representation Analysis Results
              </h4>
              {sepBtnState === "Result_table" && (
                <div
                  className={styles.download}
                  style={{ marginLeft: "12px" }}
                  onClick={handleDowndloadCSV}
                >
                  Download Table
                </div>
              )}
              {sepBtnState === "Gene_Pathway Network (Fig.1)" && (
                <div
                  className={styles.download}
                  style={{ marginLeft: "12px" }}
                  onClick={downloadPdf}
                >
                  Download Fig.1
                </div>
              )}
              {sepBtnState === "Pathway Graph (Fig.2)" && (
                <>
                  <div
                    className={styles.download}
                    style={{ marginLeft: "12px" }}
                    onClick={saveBubblePlotAsPDF_qval}
                  >
                    Download Fig.2A
                  </div>
                  <div
                  className={styles.download}
                  style={{ marginLeft: "12px" }}
                  onClick={saveBubblePlotAsPDF_pval}
                >
                  Download Fig.2B
                </div>                
                </>
              )}
              <CSVLink
                data={resultData.map(
                  ({ pvalue, qval, q_005, q_001, q_0001, ...rest }) =>
                    rest
                )}
                filename={"CANCER COMPASS_result table.csv"}
              >
                <button style={{ display: "none" }} ref={csvBtnRef}></button>
              </CSVLink>
            </div>
            <div className={styles.section}>
              <div className={styles.btnCnt}>
                <div
                  onClick={(e) => setSepBtnState(e.target.innerText)}
                  className={`${styles.sepBtn} ${
                    sepBtnState === "Result_table" ? styles.clicked : ""
                  }`}
                >
                  Result_table
                </div>
                <div
                  onClick={(e) => {
                    handleCreatePathwayNetwork();
                  }}
                  className={`${styles.sepBtn} ${
                    sepBtnState === "Gene_Pathway Network (Fig.1)"
                      ? styles.clicked
                      : ""
                  }`}
                >
                  Gene_Pathway Network (Fig.1)
                </div>
                <div
                  onClick={(e) => {
                    onHandlePathwayData();
                  }}
                  className={`${styles.sepBtn} ${
                    sepBtnState === "Pathway Graph (Fig.2)"
                      ? styles.clicked
                      : ""
                  }`}
                >
                  Pathway Graph (Fig.2)
                </div>
                <div
                  onClick={(e) => setSepBtnState(e.target.innerText)}
                  className={`${styles.sepBtn} ${
                    sepBtnState === "3D Scatter Plot (Fig.3)"
                      ? styles.clicked
                      : ""
                  }`}
                >
                  3D Scatter Plot (Fig.3)
                </div>
              </div>
            </div>
          </>
        )}

        {resultData.length !== 0 && sepBtnState === "Result_table" && (
          <TableORA
            resultData={resultData}
            selectedRows={selectedRowsForSankey}
            setSelectedRows={setSelectedRowsForSankey}
          />
        )}
        {resultData.length !== 0 &&
          sepBtnState === "Gene_Pathway Network (Fig.1)" &&
          GenePathwayNetwork_result !== undefined && (
            <>
              <div className={styles.sankeyCnt}>
                <SankeyDiagram
                  data={GenePathwayNetwork_result}
                  svgRef={svgRef}
                />
              </div>
            </>
          )}
        {resultData.length !== 0 && sepBtnState === "Pathway Graph (Fig.2)" && (
          <>
            <div className={styles.bubblePlotCnt}>
              <h3 className={styles.bubblePlotTitle}>Figure 2A. q-value plot</h3>
              <BubblePlot 
              data={pathwayData} 
              bubblePlotRef={bubblePlotRef_qval} 
              valuetype={'-log(qValue)'}/>
            </div>
            <div className={styles.bubblePlotCnt}>
              <h3 className={styles.bubblePlotTitle}>Figure 2B. p-value plot</h3>              
              <BubblePlot 
              data={pathwayData} 
              bubblePlotRef={bubblePlotRef_pval} 
              valuetype={'-log(pValue)'}/>
            </div>
          </>
        )}
        {resultData.length !== 0 && sepBtnState === "3D Scatter Plot (Fig.3)" && (
          <>
            {isClicked3Sp !== "" && (
              <>
                <div className={styles.Cnt3SP}>
                  <ScatterPlot
                    cordZcutoff={cordZcutoff}
                    cordZ={cordZ}
                    cordY={cordY}
                    cordX={cordX}
                    dataType={qValueCutoff.split("_")[1]}
                  />
                </div>
              </>
            )}
            <Table3SP
              dataType={String(qValueCutoff.split("_")[1])}
              isClicked3Sp={isClicked3Sp}
              setIsClicked3SP={setIsClicked3SP}
              setCordZcutoff={setCordZcutoff}
              setCordX={setCordX}
              setCordZ={setCordZ}
              resultData={resultData.filter((_, index) =>
                selectedRowsForSankey.includes(index)
              )}
            />
          </>
        )}
        {loading && (
          <div className={styles.loading}>
            <div className={styles.spinner}></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ORA;
